// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pIEUnIQe10SFLDTGGy6w{width:100%;margin:0 auto;padding:0 20px 92px;overflow-x:hidden;overflow-y:auto}@media (min-width:992px){.pIEUnIQe10SFLDTGGy6w{max-width:1032px}}.lCv0gxA0wwZ9dqJgaKKG{border-radius:8px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pIEUnIQe10SFLDTGGy6w`,
	"image": `lCv0gxA0wwZ9dqJgaKKG`
};
export default ___CSS_LOADER_EXPORT___;
